import { Pipe, PipeTransform } from '@angular/core';
import { AuthGateway } from '../application/gateway/AuthGateway';
import { TranslateService } from '@ngx-translate/core';
import { Lang } from '../ui/util/langs';
import { OperationDocumentType } from '../domain/models/Operation';

@Pipe({
  name: 'documentTypeName'
})
export class DocumentTypeNamePipe implements PipeTransform {

  constructor(private _authService: AuthGateway, public translate: TranslateService) {
  }


  transform(OperationDocumentType: OperationDocumentType | undefined): string {

      if(!OperationDocumentType)
        return this.translate.instant('CommonLabels.NotAvailableLabel')

      let lang = Lang.ENGLISH;

      const profile = this._authService.getUser()
      if(profile)
      {
        lang = profile.lang;
      }else{
        lang = this.translate.currentLang;
      }

      switch(lang)
      {
        case Lang.ENGLISH:
          return OperationDocumentType.name;
        case Lang.SPANISH:
          return OperationDocumentType.nameEsChile;
        default:
          return this.translate.instant('CommonLabels.NotAvailableLabel')
      }
  }

}
